import moment from 'moment'

export const columns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '发布平台',
    dataIndex: 'business.name',
    width: 120,
    align: 'left',
    key: 'business'
  },
  {
    title: '标题',
    align: 'left',
    dataIndex: 'title',
    width: 240,
    key: 'title'
  },
  {
    title: '话题',
    key: 'labels',
    width: 120,
    align: 'left',
    dataIndex: 'labels'
  },
  {
    title: '置顶类型',
    dataIndex: 'top_type',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'top_type' }
  },
  {
    title: '是否删除',
    width: 120,
    align: 'left',
    dataIndex: 'is_del',
    scopedSlots: { customRender: 'is_del' }
  },
  {
    title: '审核状态',
    align: 'left',
    width: 120,
    dataIndex: 'check_status',
    scopedSlots: { customRender: 'check_status' }
  },
  {
    title: '发布人/审核人',
    dataIndex: 'issue_name',
    width: 220,
    align: 'left',
    scopedSlots: { customRender: 'issue_name' }
  },
  {
    title: '发布时间/审核时间',
    width: 260,
    align: 'left',
    dataIndex: 'created_at',
    scopedSlots: { customRender: 'created_at' }
  },
  {
    title: '操作',
    key: 'action',
    align: 'center',
    width: 200,
    scopedSlots: { customRender: 'action' }
  }
]

export const likeColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    align: 'center'
  },
  {
    title: '点赞内容标题',
    align: 'letf',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '点赞内容ID',
    dataIndex: 'map_id',
    key: 'map_id',
    width: 180,
    align: 'center'
  },
  {
    title: '内容类型',
    align: 'center',
    dataIndex: 'type',
    key: 'type',
    width: 160,
    ellipsis: true,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '点赞用户',
    dataIndex: 'name',
    align: 'center',
    width: 200,
    ellipsis: true,
    key: 'name',
    scopedSlots: { customRender: 'name' }
    // customRender: (text, record) => {
    //   return `${text}(${record.number})`
    // }
  },
  {
    title: '点赞时间',
    align: 'center',
    width: 180,
    dataIndex: 'created_at',
    key: 'created_at',
    customRender: text => (Number(text) ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--')
  }
]

export const viewColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 100,
    align: 'center'
  },
  {
    title: '评论内容标题',
    align: 'left',
    dataIndex: 'title',
    width: 180,
    key: 'title'
  },
  {
    title: '评论用户',
    align: 'left',
    dataIndex: 'created_number',
    key: 'created_number',
    width: 120,
    customRender: (text, record) => {
      return text ? `${record.created_name}(${text})` : '--'
    }
  },
  {
    title: '评论内容ID',
    dataIndex: 'map_id',
    key: 'map_id',
    width: 100,
    align: 'center'
  },
  {
    title: '内容类型',
    align: 'center',
    dataIndex: 'type',
    key: 'type',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '评论内容',
    align: 'left',
    dataIndex: 'content',
    key: 'content',
    width: 200,
    ellipsis: true
  },
  // {
  //   title: '评论时间',
  //   align: 'left',
  //   dataIndex: 'created_at',
  //   key: 'created_at',
  //   customRender: (text) => {
  //     return Number(text) ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--'
  //   },
  // },
  // {
  //   title: '审核时间',
  //   align: 'left',
  //   dataIndex: 'approva_at',
  //   key: 'approva_at',
  //   customRender: (text) => {
  //     return Number(text) ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--'
  //   },
  // },
  {
    title: '审核人',
    align: 'left',
    dataIndex: 'approval_number',
    width: 140,
    key: 'approval_number',
    scopedSlots: { customRender: 'approval_number' }
    // customRender: (text, record) => {
    //   return Number(text) ? `${record.approval_name}(${text})` : '--'
    // },
  },
  {
    title: '楼层',
    align: 'center',
    dataIndex: 'floor',
    key: 'floor',
    width: 100,
    scopedSlots: { customRender: 'floor' }
  },
  {
    title: '回复条数',
    align: 'center',
    dataIndex: 'reply_num',
    width: 100,
    key: 'reply_num',
    ellipsis: true
  },
  {
    title: '是否删除',
    align: 'center',
    width: 100,
    dataIndex: 'is_del',
    key: 'is_del',
    scopedSlots: { customRender: 'is_del' }
  },
  {
    title: '审核状态',
    align: 'center',
    width: 100,
    dataIndex: 'approva_status',
    key: 'approva_status',
    scopedSlots: { customRender: 'approva_status' }
  },
  {
    title: '起止时间',
    align: 'left',
    dataIndex: 'created_at',
    width: 230,
    key: 'created_at',
    scopedSlots: { customRender: 'created_at' }
  },
  {
    title: '操作',
    align: 'center',
    width: 160,
    dataIndex: 'action',
    key: 'action',
    fixed: 'right',
    scopedSlots: { customRender: 'action' }
  }
]

// 评论labels
export const formLabels = [
  {
    laebl: '评论内容标题',
    key: 'title'
  },
  {
    laebl: '评论用户',
    key: 'created_user'
  },
  {
    laebl: '评论时间',
    key: 'created_at'
  },
  {
    laebl: '回复条数',
    key: 'reply_num'
  },
  {
    laebl: '审核时间',
    key: 'approva_at'
  },
  {
    laebl: '审核人',
    key: 'approval_user'
  },
  {
    laebl: '审核状态',
    key: 'approva_status'
  },
  {
    laebl: '是否删除',
    key: 'is_del'
  }
]

// 回复labels
export const replyLabels = [
  {
    laebl: '回复的评论ID',
    key: 'id'
  },
  {
    laebl: '回复用户',
    key: 'created_user'
  },
  {
    laebl: '回复时间',
    key: 'created_at'
  },
  // {
  //   laebl: '回复条数',
  //   key: 'reply_num'
  // },
  // {
  //   laebl: '审核时间',
  //   key: 'approva_at'
  // },
  // {
  //   laebl: '审核人',
  //   key: 'approval_user'
  // },
  {
    laebl: '审核状态',
    key: 'approva_status'
  },
  {
    laebl: '是否删除',
    key: 'is_del'
  }
]

// 回复评论
export const reColumns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    align: 'center'
  },
  {
    title: '回复的评论ID',
    dataIndex: 'parent_id',
    key: 'parent_id',
    align: 'center'
  },
  {
    title: '回复的评论',
    align: 'center',
    dataIndex: 'parentComment.content',
    key: 'parentComment',
    ellipsis: true
  },
  {
    title: '回复内容',
    align: 'center',
    dataIndex: 'content',
    key: 'content',
    ellipsis: true
  },
  // {
  //   title: '文章类型',
  //   align: 'center',
  //   dataIndex: 'type',
  //   key: 'type',
  //   scopedSlots: { customRender: 'type' }
  // },
  {
    title: '回复用户',
    align: 'center',
    dataIndex: 'created_number',
    key: 'created_number',
    ellipsis: true,
    customRender: (text, record) => {
      return text ? `${record.created_name}(${text})` : '--'
    }
  },
  {
    title: '回复时间',
    align: 'center',
    dataIndex: 'created_at',
    key: 'created_at',
    customRender: text => {
      return Number(text) ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--'
    }
  },
  // {
  //   title: '审核时间',
  //   align: 'center',
  //   dataIndex: 'approva_at',
  //   key: 'approva_at',
  //   ellipsis: true,
  //   customRender: (text) => {
  //     return Number(text) ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--'
  //   },
  // },
  // {
  //   title: '审核人',
  //   align: 'center',
  //   dataIndex: 'approval_number',
  //   key: 'approval_number',
  //   ellipsis: true,
  //   customRender: (text, record) => {
  //     return Number(text) ? `${record.approval_name}(${text})` : '--'
  //   },
  // },
  // {
  //   title: '回复条数',
  //   align: 'center',
  //   dataIndex: 'reply_num',
  //   key: 'reply_num',
  //   ellipsis: true,
  // },
  {
    title: '是否删除',
    align: 'center',
    dataIndex: 'is_del',
    key: 'is_del',
    ellipsis: true,
    scopedSlots: { customRender: 'is_del' }
  },
  {
    title: '审核状态',
    align: 'center',
    dataIndex: 'approva_status',
    key: 'approva_status',
    ellipsis: true,
    scopedSlots: { customRender: 'approva_status' }
  },
  {
    title: '操作',
    align: 'center',
    dataIndex: 'action',
    key: 'action',
    width: 150,
    scopedSlots: { customRender: 'action' }
  }
]
export const readRecordColumns = [
  {
    title: '序号',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    align: 'center'
  },
  {
    title: '浏览内容标题',
    align: 'letf',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '浏览内容ID',
    dataIndex: 'map_id',
    key: 'map_id',
    width: 180,
    align: 'center'
  },
  {
    title: '内容类型',
    align: 'center',
    dataIndex: 'type',
    key: 'type',
    width: 160,
    ellipsis: true,
    scopedSlots: { customRender: 'type' }
  },
  {
    title: '浏览用户',
    dataIndex: 'name',
    align: 'center',
    width: 200,
    ellipsis: true,
    key: 'name',
    scopedSlots: { customRender: 'name' }
    // customRender: (text, record) => {
    //   return `${text}(${record.number})`
    // }
  },
  {
    title: '浏览时间',
    align: 'center',
    dataIndex: 'created_at',
    width: 180,
    key: 'created_at',
    customRender: text => (Number(text) ? moment.unix(Number(text)).format('YYYY-MM-DD HH:mm:ss') : '--')
  }
]
